package com.patronat.top.ui.organisms

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.models.NavigationUiItem
import com.patronat.top.ui.molecules.branding.AppLogo
import com.patronat.top.ui.molecules.navigation.SideMenuItem
import com.patronat.top.ui.theme.SidebarBackground

// 1. UI Модель (Незалежна від бізнес-логіки)

// 2. Організм (Панель)
@Composable
fun SideNavigationPanel(
    items: List<NavigationUiItem>,
    onItemSelected: (Any) -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxHeight()
            .width(280.dp)
            .background(SidebarBackground)
            .padding(start = 32.dp, end = 24.dp, top = 40.dp, bottom = 40.dp),
        horizontalAlignment = Alignment.Start
    ) {

        AppLogo(iconSize = 40, fontSize = 28)

        Spacer(modifier = Modifier.height(60.dp))

        items.forEach { item ->
            SideMenuItem(
                item = item,
                onClick = { onItemSelected(item.id) }
            )
            Spacer(modifier = Modifier.height(20.dp))
        }
    }
}

